import { createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { Users } from '@/pages/Settings/Users/Users'
import { usersSearchSchema } from '@/pages/Settings/Users/usersSearchSchema'

export const Route = createFileRoute('/_app/settings/_userManagement/users')({
  component: Users,
  validateSearch: usersSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'read:users')
  },
  errorComponent: forbiddenErrorComponent,
})
